import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";

import PaperFragment from "../../../../helper-components/misc/PaperFragment";
import StackedHeader from "../../../../helper-components/misc/StackedHeader";
import DataGridTable from "../../../../helper-components/table/DataGridTable";

import MoveExaminationDialog from "./MoveExaminationDialog";

import { columns, defaultTableOptions } from "../../../../helper-functions/table/examinations";
import { queryExaminations, deleteExaminations, reassignExamination } from "../../../../helper-functions/api/examinationQueries";

import { getLanguage } from "../../../../config/language/language";

export default function ExaminationsTable(props) {
    const examinations = props.backend.examinations;

    const handleCreate = () => {
        props.browser.navigate(`/database/examinations/new`);
    };

    const showDeleteDialog = () => {
        props.showDialog({
            title: "Delete examination(s)",
            message: `Are you sure you want to delete the ${examinations.selected.length} selected examination(s)?`,
            actionTitle: "Delete",
            actionColor: "error",
            callback: (confirm) => handleDelete(confirm)
        });
    };

    const handleUpdate = () => {
        const id = examinations.selected?.[0]?.id;
        props.browser.navigate(`/database/examinations/${id}/edit`);
    };

    const showMoveDialog = () => {
        const examination = examinations.selected?.[0];
        if (!examination) return;

        props.showDialog({
            title: "Move examination",
            component: (
                <MoveExaminationDialog
                    {...props}
                    examination={examination}
                    onCancel={() => props.setOpenDialog(false)}
                    onConfirm={(patient) => {
                        props.setOpenDialog(false);
                        if (!patient?.id) return;
                        reassignExamination(props, { id: examination.id, patientId: patient.id });
                    }}
                />
            )
        });
    };

    const handleDelete = (confirm) => {
        if (!confirm) return;

        const ids = examinations.selected.map((patient) => patient.id);
        deleteExaminations(props, { body: { ids }, ids });
    };

    return (
        <PaperFragment
            className=""
            title={
                <StackedHeader
                    {...props}
                    title="Examinations"
                    subtitle="View and manage examinations."
                    icons={[
                        {
                            icon: <DeleteIcon />,
                            className: "tour-examinations-delete",
                            tooltip: "Delete selected examinations",
                            disabled: examinations.selected.length === 0,
                            onClick: showDeleteDialog
                        },
                        {
                            icon: <EditIcon />,
                            className: "tour-examinations-edit",
                            tooltip: "Edit selected examination",
                            onClick: handleUpdate,
                            disabled: examinations.selected.length !== 1
                        },
                        {
                            icon: <DriveFileMoveIcon />,
                            className: "tour-examinations-move",
                            tooltip: "Move selected examination to another patient",
                            onClick: showMoveDialog,
                            disabled: examinations.selected.length !== 1
                        }
                    ]}
                    buttons={[
                        {
                            icon: <AddIcon />,
                            className: "small-margin tour-examinations-new",
                            title: "New examination",
                            onClick: handleCreate
                        }
                    ]}
                />
            }
            value={
                <DataGridTable
                    {...props}
                    {...defaultTableOptions}
                    rowHeight={60}
                    states={examinations}
                    columns={columns(props)}
                    query={(options) => queryExaminations(props, options)}
                    empty={getLanguage().NO_EXAMINATIONS_FOUND}
                    refresh={10}
                />
            }
        />
    );
}
